

exports.__esModule = true;
exports.$VenmoRoute = undefined;

var _squid = require('squid');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

var _route = require('xo-third-party-components/src/venmo-billing/route');

var _route2 = _interopRequireDefault(_route);

require('xo-member-components/src/select-shipping/add-shipping/route');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $VenmoRoute = exports.$VenmoRoute = _squid.$Route.extend('$VenmoRoute', {
    path: 'venmo',
    directive: _directive2['default'],

    auth: false,
    query: [_directive.TOKEN_PARAM_NAME, _directive.VENMO_VERSION],

    trackingData: {
        fptiState: 'venmo_entrypoint',
        trackStateExit: true
    },
    children: [{
        name: '$AddShippingRoute',
        attributes: {
            token: 'token',
            'done-fn': 'done',
            sidebar: 'sidebar',
            'render-billing-add-checkbox': 'renderBillingAddCheckbox'
        }
    }, {
        route: _route2['default'],
        attributes: {
            token: 'token',
            sidebar: 'sidebar'
        }
    }]
});

angular.value("$VenmoRoute", $VenmoRoute);
_squid.$Route;

_directive.TOKEN_PARAM_NAME;

_directive.VENMO_VERSION;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-venmo/route.js
// module id = ./pages/xo-venmo/route.js
// module chunks = 0